<template>
    <div class="loader">
        <div class="progress-bar">
            <div class="progress-bar-fill">
                <div class="progress-value">
                    <div class="progress-message">{{message}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Loader",
        props: {
          "indefinite": Boolean,
          "message": String
        },
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/global";

.progress-bar {
    user-select: none;
    display: inline-flex;
    width: calc(100% - 8px);
    height: 28px;
    font-size: 20px;
    background-color: var(--accent-color-plus-25);
    border-radius: 2px;
    padding: 1px 1px 1px 1px;
    margin: 2px 4px 2px 4px;
}

$progressBarSecondary: var(--accent-color);
$progressBarPrimary: var(--accent-color-plus-10);

.progress-bar-fill {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(45deg, $progressBarPrimary 0px, $progressBarPrimary 15px, $progressBarSecondary 15px, $progressBarSecondary 30px);
    background-size: 100% 66px;
    border-radius: 2px;
    animation: loading 1s linear infinite;
    box-shadow: inset 0px 0px 10px rgba(255,255,255,0.4);
}

.progress-value {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $progressBarPrimary;
    padding: 0px 5px 0px 5px;
}

.progress-message {
    font-size: 14px;
    display: inline-block;
    margin: 0px 5px 0px 5px;
    color: var(--accent-color-plus-75);
}

@keyframes loading {
    0% {
        background-position: 0% 100%
    }
    50% {
        background-position: 0% 50%
    }
    100% {
        background-position: 0% 0%
    }
}

</style>